<template>
    <div class="page-wrap">
        <div class="page-bar">
            <div>
                <div class="page-bar-sub">Work</div>
                <div class="page-bar-main">Forms</div>
            </div>
        </div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <div class="page-filters pf-bar">
                <div class="pf-search">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.35-4.35" /></svg>
                    <input type="text" v-model="searchQ" placeholder="Search" aria-label="Search" @input="search()" />
                </div>
                <select v-if="$store.state.user.teamHubRole == 'Admin'" v-model="formStatus" @change="getForms()">
                    <option value="published">Published</option>
                    <option value="unpublished">Unpublished</option>
                </select>
                <span class="pf-spacer"></span>
                <div v-if="$store.state.user.teamHubRole == 'Admin'" @click="addNewForm()" class="add-btn">Add</div>
            </div>
            <table class="full-table">
                <tbody>
                    <tr v-for="(form, i) in forms" :key="i">
                        <td><a :href="'/team-hub?formID=' + form.ID" target="_blank">{{ form.Name }}</a></td>
                        <td v-if="$store.state.user.teamHubRole == 'Admin' || ($store.state.user.companyID == 1 && $store.state.user.isAdmin)" style="text-align:center">
                            <a v-if="$store.state.user.teamHubRole == 'Admin' || form.ID == 8" @click.prevent="viewSubmissions(form)">Submissions</a>
                        </td>
                        <td v-if="$store.state.user.isAdmin" style="text-align:center">
                            <a @click.prevent="sendText(form)">Send Text</a>
                        </td>
                        <td v-if="$store.state.user.teamHubRole == 'Admin'" style="text-align:center">
                            <a @click.prevent="editForm(form)">Edit</a>
                        </td>
                        <td v-if="$store.state.user.teamHubRole == 'Admin' && form.Published" style="text-align:center">
                            <a @click="unpublish(form)">Unpublish</a>
                        </td>
                        <td v-if="$store.state.user.teamHubRole == 'Admin' && !form.Published" style="text-align:center">
                            <a @click="publish(form)">Publish</a>
                        </td>
                        <td v-if="$store.state.user.teamHubRole == 'Admin' && !form.Published" style="text-align:center">
                            <a @click="deleteForm(form)">Delete</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="showSendText" class="error-msg-wrap">
            <div class="form-wrapper slide-up">
                <div class="form-close">
                    <button type="button" class="form-close-x" title="Close" @click="() => { showSendText = false }">&times;</button>
                </div>
                <div>
                    <h3>Phone Number</h3>
                    <phone-input v-model="sendTextFormData.phone" />
                </div>
                <div>
                    <h3>Message (link will be included)</h3>
                    <textarea style="height:170px" v-model="sendTextFormData.text" />
                </div>
                <input :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submitSendText()" />
            </div>
        </div>

        <form-view-submissions v-if="showSubmissions" :formToView="formToViewSubmissions" @close="() => {showSubmissions = false}" />
        <add-edit-form v-if="showAddForm" :formToEdit="formToEdit" @close="closeAddEdit()" />
        <confirm-delete v-if="showConfirmUnpublish" @confirm="unpublishConfirm" @cancel="() => { showConfirmUnpublish = false; }" msg="Are you sure you would like to unpublish this form?"/>
        <confirm-delete v-if="showConfirmPublish" @confirm="publishConfirm" @cancel="() => { showConfirmPublish = false; }" msg="Are you sure you would like to publish this form?"/>
        <confirm-delete v-if="showConfirmDelete" @confirm="deleteConfirm" @cancel="() => { showConfirmDelete = false; }" msg="Are you sure you would like to PERMANENTLY DELETE this form?"/>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import PhoneInput from '@/components/PhoneInput.vue';
import { normalizePhone, PHONE_ERROR } from '@/phone';
import AddEditForm from '@/components/AddEditForm.vue';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import FormViewSubmissions from '@/components/FormViewSubmissions.vue';

export default defineComponent({
    name: 'FormsView',
    components: {
        PhoneInput,
        AddEditForm,
        ConfirmDelete,
        FormViewSubmissions,
    },
    data() {
        return {
            allForms: [] as any,
            forms: [] as any,
            searchQ: '',
            showAddForm: false,
            formToEdit: null as any,
            formStatus: 'published',
            formToUnpublish: null as any,
            showConfirmUnpublish: false,
            formToPublish: null as any,
            showConfirmPublish: false,
            formToDelete: null as any,
            showConfirmDelete: false,
            formToViewSubmissions: null as any,
            showSubmissions: false,
            sendTextFormData: {
                phone: '',
                formID: null as any,
                text: '',
            },
            showSendText: false,
            disableButton: false
        }
    },
    async created() {
        await this.getForms();

        if(this.$route.query.formID) {
            const form = this.allForms.find((f: any) => {
                return f.ID == this.$route.query.formID;
            });
            if(form) {
                this.formToViewSubmissions = form;
                this.showSubmissions = true;
            }
        }

        this.$store.state.routeLoaded = true;
    },
    methods: {
        async getForms() {
            let unpublishedQuery = '';
            if(this.formStatus == 'unpublished') {
                unpublishedQuery = '?unpublished=t';
            }
            await axios.get(`${this.$store.state.apiUrl}/api/forms/companyforms/${this.$store.state.user.companyID}${unpublishedQuery}`)
                .then(resp => {
                    this.forms = resp.data;
                    this.allForms = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        search() {
            if(this.searchQ.length < 3) {
                this.forms = this.allForms;
            } else {
                const searchQLower = this.searchQ.toLowerCase();
                this.forms = this.allForms.filter((form: any) => {
                    return form.Name.toLowerCase().includes(searchQLower);
                })
            }
        },
        addNewForm() {
            this.formToEdit = null;
            this.showAddForm = true;
        },
        editForm(form: any) {
            this.formToEdit = form.ID;
            this.showAddForm = true;
        },
        closeAddEdit() {
            this.getForms();
            this.showAddForm = false;
        },
        unpublish(form: any) {
            this.formToUnpublish = form;
            this.showConfirmUnpublish = true;
        },
        async unpublishConfirm() {
            this.showConfirmUnpublish = false;
            await axios.post(`${this.$store.state.apiUrl}/api/forms/unpublish/${this.formToUnpublish.ID}`)
                .then(resp => {
                    this.getForms();
                })
                .catch(e => {
                    alert('There was an error');
                    console.log(e);
                })
        },
        publish(form: any) {
            this.formToPublish = form;
            this.showConfirmPublish = true;
        },
        async publishConfirm() {
            this.showConfirmPublish = false;
            await axios.post(`${this.$store.state.apiUrl}/api/forms/publish/${this.formToPublish.ID}`)
                .then(resp => {
                    this.getForms();
                })
                .catch(e => {
                    alert('There was an error');
                    console.log(e);
                })
        },
        deleteForm(form: any) {
            this.formToDelete = form;
            this.showConfirmDelete = true;
        },
        async deleteConfirm() {
            this.showConfirmDelete = false;
            await axios.delete(`${this.$store.state.apiUrl}/api/forms/${this.formToDelete.ID}`)
                .then(resp => {
                    this.getForms();
                })
                .catch(e => {
                    alert('There was an error');
                    console.log(e);
                })
        },
        viewSubmissions(form: any) {
            this.formToViewSubmissions = form;
            this.showSubmissions = true;
        },
        sendText(form: any) {
            this.sendTextFormData = {
                phone: '',
                text: `${this.$store.state.user.companyName} is requesting you to fill out this ${form.Name} form.\n\nThank You!`,
                formID: form.ID
            }
            this.showSendText = true;
        },
        async submitSendText() {
            if(!this.sendTextFormData.phone) {
                alert('Add recipient phone number');
                return;
            }
            if(!this.sendTextFormData.text) {
                alert('Include a message to be sent');
                return;
            }
            if(!normalizePhone(this.sendTextFormData.phone)) {
                alert(PHONE_ERROR);
                return;
            }
            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/forms/sendtext`, this.sendTextFormData)
                .then(resp => {
                    alert('Text has been sent!');
                    this.sendTextFormData.phone = '';
                })
                .catch(e => {
                    alert('There was an error, make sure you have entered a valid phone number');
                    console.log(e);
                })

            this.disableButton = false;
        }
    }
});
</script>
